export default __webpack_public_path__ + "static/sla_logo-96e6cab682c890208c445807e588ac94.png";